declare global {
  interface Window {
    __cdxEnv: Record<string, string | undefined>;
  }
}

if (process.env.NODE_ENV !== "production" || !window.__cdxEnv) window.__cdxEnv = {};

const cdxEnv = {
  API_HOST: import.meta.env.REACT_APP_API_HOST || window.__cdxEnv.API_HOST,
  IMG_RESIZER_HOST: import.meta.env.REACT_APP_IMG_RESIZER_HOST || window.__cdxEnv.IMG_RESIZER_HOST,
  PUSH_HOST: import.meta.env.REACT_APP_PUSH_HOST || window.__cdxEnv.PUSH_HOST,
  ROOM_SYNC_HOST: import.meta.env.REACT_APP_ROOM_SYNC_HOST || window.__cdxEnv.ROOM_SYNC_HOST,
  MAX_STORAGE_MBS: import.meta.env.REACT_APP_MAX_STORAGE_MBS || window.__cdxEnv.MAX_STORAGE_MBS,
  APP_NAME: window.__cdxEnv.APP_NAME,
  DEPLOYMENT_LABEL: import.meta.env.VITE_DEPLOYMENT_LABEL || window.__cdxEnv.DEPLOYMENT_LABEL,

  ON_PREMISE: import.meta.env.REACT_APP_ON_PREMISE,
  EXTRACT_SUBDOMAIN_REGEXP: import.meta.env.REACT_APP_EXTRACT_SUBDOMAIN_REGEXP || "",
  // Org to talk to when the hostname carries no subdomain (single-host setups: on-premise, dev
  // machines without dnsmasq). Ignored as soon as EXTRACT_SUBDOMAIN_REGEXP matches.
  DEFAULT_ACCOUNT: import.meta.env.REACT_APP_DEFAULT_ACCOUNT || "",
  OPEN_APP_HOST: import.meta.env.REACT_APP_OPEN_APP_HOST || "",
  HOST_PATTERN: import.meta.env.REACT_APP_HOST_PATTERN || "",
  STRIPE_PUBLIC_KEY: import.meta.env.REACT_APP_STRIPE_PUBLIC_KEY || "",
  TRELLO_API_KEY: import.meta.env.REACT_APP_TRELLO_API_KEY || "",
  UPLOAD_HOST: import.meta.env.REACT_APP_UPLOAD_HOST || "",
  CDN_HOST: import.meta.env.REACT_APP_CDN_HOST || "",
  UPTIME_ROBOT_PUBLIC_API_KEY: import.meta.env.REACT_APP_UPTIME_ROBOT_PUBLIC_API_KEY || "",

  VAPID_PUBLIC_KEY: import.meta.env.REACT_APP_VAPID_PUBLIC_KEY || "",
  CELLO_PRODUCT_ID: import.meta.env.REACT_APP_CELLO_PRODUCT_ID || "",
  CELLO_ASSET_HOST: import.meta.env.REACT_APP_CELLO_ASSET_HOST || "",

  // Build-time: vars with REACT_APP_ or VITE_ prefix are auto-available via import.meta.env (see vite.config.ts envPrefix)
  // Runtime (Docker): add $PLACEHOLDER entries to index.html's window.__cdxEnv (substituted by envsubst at container start)
  //   note that the docker-compose.yml contains entries like: `REACT_APP_API_HOST: ${API_HOST}`
  // Runtime (S3): deploy.js rewrites window.__cdxEnv via sed after build
};

export default cdxEnv;
